// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"7d1d08a5","63":"a01cc165","71":"5337bf65","91":"053510cf","96":"97226d74","249":"04ac0b9f","261":"254d2d99","331":"a7bd5441","335":"68ff5684","467":"7c1afdd5","539":"77e98a7f","642":"938be255","715":"0ae3d74c","783":"0132f097","979":"7571d51a"}[chunkId] + ".chunk.js";
};